import React from 'react'

import IcaewConsentModal from '@/components/modals/IcaewModals/components/IcaewConsentModal'
import IcaewPricingModal from '@/components/modals/IcaewModals/components/IcaewPricingModal'
import { useSessionMetadataOrFail } from '@/hooks/useSessionMetadataOrFail'

const IcaewModals: React.FC = () => {
  const icaewModals = useSessionMetadataOrFail().icaewModals

  if (icaewModals?.showPricingModal) {
    return <IcaewPricingModal />
  }

  if (icaewModals?.showDataSharingModal) {
    return <IcaewConsentModal />
  }

  return null
}

export default IcaewModals
